import React from "react";

const PageInner = ({ children }) => {
  return <div className="inner">{children}</div>;
};

export default PageInner;
